import React from 'react';
import { ArrowLeft, Save } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdForm = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-6 animate-fadeIn">
      <div>
        <Link to="/admin/ads" className="inline-flex items-center text-xs font-semibold text-gray-400 hover:text-white uppercase tracking-wider">
          <ArrowLeft size={14} className="mr-1" /> Back to Campaigns
        </Link>
        <h1 className="text-3xl font-bold text-white tracking-tight mt-2">Create Ad Campaign</h1>
        <p className="text-gray-400 text-sm mt-1">Configure target gym audiences and CPV limits for video sponsorships.</p>
      </div>

      <div className="bg-[#0F172A] border border-[#1E293B] rounded-xl shadow-lg p-6 lg:p-8 space-y-6">
        <p className="text-sm text-gray-400 italic">Ad Campaign Management details will be finalized in Phase 3. Deployed placeholder views ready.</p>
        <div className="flex justify-end gap-4 border-t border-[#1E293B] pt-6">
          <Link to="/admin/ads" className="px-6 py-2.5 bg-[#1E293B] border border-[#334155] rounded-lg text-sm text-gray-300 font-semibold hover:border-gray-500">Cancel</Link>
          <button type="button" className="flex items-center px-6 py-2.5 bg-[#6CD800] text-[#0B0F19] font-bold rounded-lg text-sm transition-opacity opacity-50 cursor-not-allowed">
            <Save size={16} className="mr-2" /> Save Campaign
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdForm;
